// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Form, FormGroup, Label, View } from "@components";
import { reduxForm, Field } from "redux-form";
import type { FormProps } from "redux-form";
import { DatePickerFormWrapper, Dropdown } from "@components/form";
import { HIERARCHY_CHANGE_TYPES } from "@modules/hierarchy/constants/change-log";
import type { AuthoredBy } from "@types";
import { formatAuthoredBy } from "@transformers/names";
import config from "@config";
type Props = $Exact<{
  isLoading: boolean,
  handleSubmit: (formData: Object) => void,
  getChangelog: () => void,
  onExport: () => void,
  changelogUsers: Array<AuthoredBy>,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class ChangelogFilter extends React.Component<Props> {
  resetForm = () => {
    this.props.reset();
    this.props.getChangelog();
  };

  get changeTypeOptions(): Array<*> {
    return Object.keys(HIERARCHY_CHANGE_TYPES).map(changeType => ({
      value: changeType,
      label: this.props.t(changeType),
    }));
  }

  get userOptions(): Array<*> {
    return this.props.changelogUsers.map(user => ({
      value: user.id,
      label: formatAuthoredBy(user),
    }));
  }

  render() {
    return (
      <Form
        onSubmit={this.props.handleSubmit}
        className="d-flex justify-content-between align-items-end"
      >
        <View
          direction="row"
          alignItems="end"
          gap={2}
          flex={1}
          className="flex-wrap"
          separator="top"
        >
          <FormGroup className="mr-3a">
            <Label for="fromDate">{this.props.t("DATE_FROM")}</Label>
            <Field
              name="from"
              component={DatePickerFormWrapper}
              customProps={{ dateFormat: config.dateFormatBE, id: "fromDate" }}
            />
          </FormGroup>
          <FormGroup className="mr-3a">
            <Label for="toDate">{this.props.t("DATE_TO")}</Label>
            <Field
              name="to"
              component={DatePickerFormWrapper}
              customProps={{ dateFormat: config.dateFormatBE, endDate: true, id: "toDate" }}
            />
          </FormGroup>
          <FormGroup className="mr-3a w-200-px p-0">
            <Label for="operation">{this.props.t("UPDATE_TYPE")}</Label>
            <Field
              id="operation"
              name="operation"
              component={Dropdown}
              options={this.changeTypeOptions}
            />
          </FormGroup>
          <FormGroup className="mr-3a w-200-px p-0">
            <Label for="createdBy">{this.props.t("USER")}</Label>
            <Field
              id="createdBy"
              name="createdBy"
              component={Dropdown}
              options={this.userOptions}
            />
          </FormGroup>
          <View direction="row" gap={1} padding="0 0 1rem">
            <Button onClick={this.props.handleSubmit} materialIcon="replay_circle_filled">
              {this.props.t("SUBMIT")}
            </Button>
            {this.props.dirty ? (
              <Button color="secondary" onClick={this.resetForm}>
                {this.props.t("RESET")}
              </Button>
            ) : null}
          </View>
        </View>
      </Form>
    );
  }
}

export default reduxForm({
  form: "hierarchy-change-log-filter",
})(localize()(ChangelogFilter));
